// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"ManageComments_PageHolder__1smyw","TotalScore":"ManageComments_TotalScore__33EDQ","Rate":"ManageComments_Rate__2b70y"};